import { render, staticRenderFns } from "./boundlessCarving.vue?vue&type=template&id=8ce07b3a&scoped=true"
import script from "./boundlessCarving.vue?vue&type=script&lang=js"
export * from "./boundlessCarving.vue?vue&type=script&lang=js"
import style0 from "./boundlessCarving.vue?vue&type=style&index=0&id=8ce07b3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce07b3a",
  null
  
)

export default component.exports